import React from 'react';
import { useSelector } from 'react-redux';

import Skeleton from '../../../../../components/Skeleton';
import AppIcon from '../../../../../components/AppIcon';
import { aiAppTrendsSelector, aiDashboardAppsSelector } from '../../selectors';

const LegendApp = () => {
  const { filters } = useSelector(aiAppTrendsSelector);
  const apps = useSelector(aiDashboardAppsSelector);

  if (apps.settings.pending) {
    return <Skeleton width={100} height={18} className="d-flex" />;
  }

  if (apps.settings.error) return null;

  const activeApp = apps.data?.top_apps.find((app) => app.unified_ref_no === filters.app_uid);

  if (!activeApp) return null;

  return (
    <div key={activeApp.unified_ref_no} className="legend-app">
      <AppIcon
        alt={activeApp.name}
        url={activeApp.icon_url}
        store={activeApp.store}
        size={18}
        hideHtmlTitle
        withBorder
        containerClasses="legend-app__icon"
      />
      <span className="legend-app__name">{activeApp.name}</span>
    </div>
  );
};

export default LegendApp;
